import Icon, {LoadingOutlined} from '@ant-design/icons'
import {Avatar, Button, List, Spin} from 'antd'
import {search_fetchObjects_Api, search_getTags_Api, url_getMetaTags_Api,} from 'apis'
import {articleModel} from 'apis/model'
import {getId, getType} from 'apis/model/base'
import classNames from 'classnames'
import getAvatar from 'helpers/getAvatar'
import getTitle from 'helpers/getTitle'
import _ from 'lodash'
import useAsyncAction from 'modules/asyncCache/useAsyncAction'
import useTranslate from 'modules/local/useTranslate'
import {permissionCodes} from 'modules/permissions/contants'
import PermissionContext from 'modules/permissions/PermissionContext'
import React, {useCallback, useContext, useEffect, useMemo, useRef, useState,} from 'react'
import {HiPaperAirplane} from 'react-icons/hi2'
import {IoIosClose} from 'react-icons/io'
import {PiPlusBold} from 'react-icons/pi'
import {RiBarChart2Fill, RiImageLine, RiQuillPenFill, RiWechatLine,} from 'react-icons/ri'
import ReactPlayer from 'react-player'
import {connect, ReactReduxContext} from 'react-redux'
import {Link, useHistory} from 'react-router-dom'
import useClickAway from 'react-use/lib/useClickAway'
import {branch} from 'recompose'
import {getLogin} from 'redux/selectors'
import ChannelContext from 'views/Channel/ChannelContext'
import {SelectList} from 'views/Search/SelectList'
import {useDeBounceValue} from 'views/Search/useDeBounceValue'
import {getResponseItems} from 'views/Shared'
import {NullAsDefault, renderIfElse} from '../views/Shared'
import {BaseEmbed} from './Feed/BaseEmbed'
import ContentEditableInput from './Feed/InputBoard/ContentEditableInput'
import {encryptMentionTitle, mark_as_mention, MentionSuggestionItem, renderMention,} from './Feed/Mention'
import MentionDataContext, {MentionDataProvider,} from './Feed/MentionDataContext'
import {VideoEmbed} from './Feed/VideoEmbed'
import './InputBar.css'
import {LayoutContext} from './layouts/Default/LayoutContext'
import {CodiSelectorActions, useInputUtils,} from './RichSlateEditor/utils/useEditorUtils'
import {LoadingSkeleton} from "../views/Loading/LoadingSkeleton";


export const gridStyle = {
    width: '100%',
    padding: '0.3em 1em',
    lineHeight: '2em',
}
export const useSuggestMentions = (value) => {
    const apiInfo = useMemo(() => search_fetchObjects_Api(), [])
    const [data, setData] = useState([])
    const debounceValue = useDeBounceValue(value, 300)
    const {
        response,
        isLoading = false,
        handleAsyncAction,
    } = useAsyncAction({
        apiInfo,
        onSuccess: (__, data) => {
            setData([
                ...Array.from(getResponseItems(data?.response) ?? [])
                    .map((item) => ({
                        name: getTitle(item),
                        type: _.get(item, 'owner._type'),
                        owner_id: _.get(item, 'owner.id'),
                        id:
                            _.get(item, 'owner.username') ||
                            _.get(item, 'owner.idname') ||
                            _.get(item, 'owner.id'),
                        link: `/${_.get(item, 'owner._type')}/${
                            _.get(item, 'idname') || _.get(item, 'owner.username')
                        }`,
                        label: getTitle(item),
                        avatar: getAvatar(item),
                    }))
                    .filter((item, i) => i < 7),
            ])
        },
    })

    useEffect(() => {
        if (debounceValue && debounceValue.length > 0) {
            handleAsyncAction({
                keyword: debounceValue,
            })
        } else {
            setData([])
        }
    }, [debounceValue])

    return {
        isLoading,
        data,
    }
}
export const useTagSuggestMentions = (value = '') => {
    const debounceValue = useDeBounceValue(value, 300)
    const {
        response,
        isLoading = false,
        handleAsyncAction,
    } = useAsyncAction({
        apiInfo: search_getTags_Api,
    })
    useEffect(() => {
        if (debounceValue && debounceValue.length > 0) {
            handleAsyncAction(
                {},
                {
                    keyword: debounceValue,
                }
            )
        }
    }, [debounceValue])

    const suggestions = [
        {
            label: value,
            name: '#' + value,
            link: `/t/${value}`,
        },
        ..._.get(response, 'data.data', [])
            .map((item) => ({
                item,
                label: _.get(item, 'tags'),
                name: '#' + _.get(item, 'tags'),
                link: `/t/${_.get(item, 'tags')}`,
            }))
            .filter((item, i) => _.get(item, 'tags') !== value && i < 7),
    ]
    return {isLoading, data: suggestions}
}

function withModifier(text, modifier = '@', min = 0) {
    const string = String(text ?? '')
    if (string.length > _.defaultTo(min, 0)) {
        return string[0] === modifier || string.endsWith(`\n${modifier}`)
    } else {
        return false
    }
}

export const useInputBar = ({
                                name,
                                value,
                                mention_count,
                                onChange = NullAsDefault,
                                onMatched = NullAsDefault,
                                willDismiss = NullAsDefault,
                                onMentioned = NullAsDefault,
                            }) => {
    const uid = useRef(Number(mention_count ?? 0))

    const [selection, setSelection] = useState([, ,])

    const handleSelect = (e) => {
        setSelection([e.target.selectionStart, e.target.selectionEnd])
        const str = e.target.value
        let end = Math.max(e.target.selectionEnd, 0)
        for (
            let i = end;
            i < str.length && str[i] !== ' ' && str[i] !== '\n';
            i++
        ) {
            end += 1
        }

        let start = end
        let text = ''
        if (str && end) {
            for (let i = end - 1; i >= 0 && str[i] !== ' ' && str[i] !== '\n'; i--) {
                start = i
                text = (str[i] ?? '') + (text ?? '')
            }
            const selected_text = {
                start,
                end,
                text: text.substring(1),
            }
            willDismiss(str, text)
            if (withModifier(text, '@', 0)) {
                onMatched(selected_text, '@')
            }
            if (withModifier(text, '#', 1)) {
                onMatched(selected_text, '#')
            }
        } else if (_.isEmpty(str)) {
            onMatched('')
        }
    }

    const {store} = useContext(ReactReduxContext)

    const mention = (values) => {
        const {owner, link, content} = values ?? {}
        const owner_id = getId(owner)
        const owner_type = getType(owner)
        // const name = encryptMentionTitle(link)
        const string = `@${owner_type}:${owner_id}:${encodeURI(link)}`
        const key = mark_as_mention(link, {
            owner_id,
            owner_type,
            index: uid.current,
        })
        uid.current = uid.current + 1
        const _text =
            (String(content ?? '').length > 0 ? `${content} ` : ` `) + `${string} `
        onMentioned({
            text: _text,
            mention: {[key]: string},
        })
    }

    const utils = useInputUtils({
        store,
        hasSelection:
            Array.from(selection ?? []).length > 1
                ? selection[0] === selection[1]
                : false,
        handleSubmit: (action, values) => {
            switch (action) {
                case CodiSelectorActions.CODI:
                    mention(values)
                    break
                default:
                    break
            }
        },
    })

    const actions = Array.from(utils?.actions ?? [])

    return {
        name,
        actions,
        mention,
        text: value,
        handleSelect,
        handlechange: onChange,
    }
}

export const InputBarContainer = React.forwardRef(
    ({children, ...props}, ref) => {
        const data = useInputBar({...props, ref})
        return children(data)
    }
)

const InputBar = ({
                      rows = 3,
                      style = {},
                      defaultHeight = 45,
                      defaultValue = '',
                      defaultImageIds = [],
                      textOnly,
                      mention_count,
                      message = false,
                      bordered = true,
                      isLoading = false,
                      placement = 'top',
                      placeholder = 'share discussion',
                      handleSubmit: onSubmit = NullAsDefault,
                      onItemClick = NullAsDefault,
                      className = 'background',
                  }) => {
    const translate = useTranslate()
    const history = useHistory()
    const {item} = useContext(ChannelContext)
    const {isSm} = useContext(LayoutContext)
    const [loading, setLoading] = useState(false)
    const [imageIds, setImageIds] = useState(defaultImageIds)
    const [text, setText] = useState(defaultValue)
    const [linkMeta, setLinkMeta] = useState()
    const mentionRef = useRef()
    const textAreaRef = useRef()
    const popupRef = useRef(null)

    // submittingRef: mutex chống duplicate submit
    // textRef: mirror đồng bộ của text state, giải quyết stale closure
    // Khi Enter nhấn nhanh liên tục, handleSubmit chạy trên closure cũ
    // nên đọc `text` state sẽ bị stale — phải dùng ref để lấy giá trị hiện tại
    const submittingRef = useRef(false)
    const textRef = useRef(defaultValue)

    useClickAway(popupRef, () => {
        handleOnClicks.none()
    })

    const [select, setSelect] = useState(null)
    const [selection, setSelection] = useState([, ,])
    const [height, setHeight] = useState(defaultHeight)
    const handleOnClicks = useMemo(
        () => ({
            none: setSelect.bind(null, null),
            options: setSelect.bind(null, 'options'),
            file: setSelect.bind(null, 'file'),
            emoji: setSelect.bind(null, 'emoji'),
        }),
        []
    )
    // isReady dùng text state (cho re-render UI) — textRef dùng cho logic guard
    const isReady = !_.isEmpty(text) || !_.isEmpty(imageIds)

    useEffect(() => {
        if (!text || text.length === 0) {
            setHeight(defaultHeight)
        } else {
            // B7: guard trường hợp ref chưa mount hoặc scrollHeight = 0
            const scrollH = textAreaRef.current?.scrollHeight ?? defaultHeight
            setHeight(Math.min(Math.max(scrollH, defaultHeight), 200))
        }
    }, [text])

    // setText wrapper: giữ textRef đồng bộ với state ở mọi nơi setText được gọi
    const setTextSync = (val) => {
        const resolved = typeof val === 'function' ? val(textRef.current) : val
        textRef.current = resolved
        setText(resolved)
    }

    // B9: handleOnchange là single source of truth khi user gõ trực tiếp
    const handleOnchange = (e) => {
        setTextSync(e.target.value)
    }

    const {data: suggestions, isLoading: mentionLoading = false} =
        useSuggestMentions(mentionRef.current?.text)

    const isOpenedSuggestions = mentionRef.current?.prefix === '@'

    const {data: tags, isLoading: tagsLoading = false} = useTagSuggestMentions(
        mentionRef.current?.text
    )

    const isOpenedTagSuggestions = mentionRef.current?.prefix === '#'

    const uid = useRef(Number(mention_count ?? 0))

    const {push = NullAsDefault} = useContext(MentionDataContext)

    const focusInput = useCallback(() => {
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                if (textAreaRef.current) textAreaRef.current.focus()
            })
        })
    }, [])

    const handleSubmit = async (text, photo_ids = []) => {
        // Gate 1: mutex ref — đồng bộ, không bị stale closure
        if (submittingRef.current) return

        // Gate 2: đọc textRef (không phải text param) để lấy giá trị HIỆN TẠI
        // Lý do: khi Enter nhấn nhanh, text param là snapshot từ closure cũ
        // textRef.current luôn là giá trị mới nhất dù closure nào gọi
        const currentText = textRef.current
        if (!String(currentText ?? '').length && !photo_ids?.length) return

        // Gate 3: loading từ props
        if (!!isLoading) return

        // Lock NGAY — trước bất kỳ await nào
        submittingRef.current = true
        setLoading(true)

        // Clear text NGAY ĐỒNG BỘ qua ref trước khi await
        // Điều này đảm bảo: nếu finally chạy và reset submittingRef=false,
        // lần Enter tiếp theo sẽ bị Gate 2 chặn vì textRef.current = ''
        setTextSync('')

        try {
            await onSubmit({
                description: currentText,
                photos: photo_ids.join(","),
                embed_data: linkMeta ? JSON.stringify(linkMeta) : undefined,
            })
            // B2+B3: clear ảnh và link embed sau submit thành công
            setImageIds([])
            setLinkMeta(undefined)
        } catch (err) {
            // Nếu lỗi: khôi phục lại text để user không mất nội dung
            setTextSync(currentText)
            console.error('[InputBar] submit error:', err)
        } finally {
            submittingRef.current = false
            setLoading(false)
            focusInput()
        }
    }

    const {store} = useContext(ReactReduxContext)

    const {actions = []} = useInputUtils({
        store,
        hasSelection:
            Array.from(selection ?? []).length > 1
                ? selection[0] === selection[1]
                : false,
        handleSubmit: (action, values) => {
            const {owner, link, content} = values ?? {}
            const owner_id = getId(owner)
            const owner_type = getType(owner)
            switch (action) {
                case CodiSelectorActions.CODI:
                    const name = encryptMentionTitle(link)
                    const string = `@${owner_type}:${owner_id}:${encodeURI(link)}`
                    const key = mark_as_mention(link, {
                        owner_id,
                        owner_type,
                        index: uid.current,
                    })
                    uid.current = uid.current + 1
                    push({
                        [key]: string,
                    })
                    const _text =
                        (String(content ?? '').length > 0 ? `${content} - ` : '') + `${string} `
                    insertText(_text)
                    break
                default:
                    break
            }
        },
    })

    const insertText = useCallback((value, suffix = ' ') => {
        // Dùng textRef.current thay vì props.value để tránh stale closure
        const _value = textRef.current ?? ''
        const _mentionStr = `${mentionRef.current?.prefix ?? ''}${mentionRef.current?.text ?? ''}`
        const newValue = _value
            .split(' ')
            .map((e) => {
                const ee = e
                    .split('\n')
                    .map((line) => (line === _mentionStr ? ` ${value}${suffix}` : line))
                    .join('\n')
                return ee === _mentionStr ? `${value}${suffix}` : ee
            })
            .join(' ')
        setTextSync(newValue)
        mentionRef.current = {}
        focusInput()
    }, [focusInput])

    const insertHash = useCallback((value) => insertText(value), [insertText])
    const insertMention = useCallback((value) => insertText(value), [insertText])

    // ✅ FIX 4: handleOnKeyDown cũng check submittingRef thay vì chỉ check `loading` state
    const handleOnKeyDown = (e, params) => {
        if (submittingRef.current) return // chặn sớm hơn, trước cả loading state

        if (isOpenedSuggestions || mentionRef.current?.prefix === '@') {
            if ([40, 38, 13].includes(e.keyCode) || e.key === 'Enter') {
                e.preventDefault()
                return
            }
        }
        if (isOpenedTagSuggestions || mentionRef.current?.prefix === '#') {
            if ([40, 38, 13].includes(e.keyCode) || e.key === 'Enter') {
                e.preventDefault()
                return
            }
        }
        if (e.key === 'Escape') {
            mentionRef.current = {}
        }
        if (!!isSm) {
            if (e.key === 'Enter') {
                e.preventDefault()
                document.execCommand('insertLineBreak')
            }
        } else {
            if (e.key === 'Enter' && e.shiftKey) {
                e.preventDefault()
                document.execCommand('insertLineBreak')
            } else if (e.key === 'Enter') {
                e.preventDefault()
                // Dùng textRef.current (không phải `text` closure) để tránh stale value
                // khi Enter nhấn nhanh liên tục trước khi React re-render
                if (!textAreaRef.current?.state?.isLoading && textRef.current) {
                    handleSubmit(textRef.current)
                }
            }
        }
    }

    const {isLoading: loadingMeta, handleAsyncAction: getMetaFromUrl} =
        useAsyncAction({
            apiInfo: url_getMetaTags_Api,
            onSuccess: (result, asyncApi) => {
                const {response} = asyncApi
                const linkMeta = _.get(response, 'data')
                if (linkMeta) {
                    setLinkMeta(linkMeta)
                }
            },
        })

    // B6: canSubmit phải dùng `loading` state (không dùng submittingRef.current trực tiếp)
    // Vì ref thay đổi không trigger re-render → button không update visual kịp
    // `loading` state được set cùng lúc với submittingRef nên vẫn sync
    const canSubmit = !_.some([loading, isLoading, tagsLoading, mentionLoading], Boolean)

    // handlePaste: extract ra khỏi JSX để dễ test và đọc
    const handlePaste = useCallback((e) => {
        e.preventDefault()
        const pastedText = e.clipboardData.getData('Text')
        if (!pastedText) return

        const LINK_DETECTION_REGEX = /(?:https?|ftp):\/\/[^\s/$.?#].[^\s]*/g
        setTextSync(textRef.current + pastedText)

        if (LINK_DETECTION_REGEX.test(pastedText)) {
            getMetaFromUrl({ content: pastedText })
        }
    }, [getMetaFromUrl])

    // handleMentionClick: extract ra khỏi JSX
    const handleMentionClick = useCallback(({id, type, name}) => {
        if (mentionRef.current?.prefix && mentionRef.current?.text) {
            const string = `@${type}:${id}:${encodeURI(name)}`
            insertMention(string)
        }
    }, [insertMention])

    const {handleSelect} = useInputBar({
        value: text,
        onChange: handleOnchange,
        mention_count,
        name: 'description',
        onMatched: (value, prefix) => {
            switch (prefix) {
                case '#':
                case '@':
                    mentionRef.current = {
                        ...(value ?? {}),
                        prefix,
                    }
                    break
                default:
                    mentionRef.current = {}
                    break
            }
        },
        willDismiss: (str, text) => {
            if (isOpenedTagSuggestions || isOpenedSuggestions) {
                if (_.isEmpty(text ?? '')) {
                    mentionRef.current = {}
                } else if (
                    _.isEmpty(
                        str.substring(mentionRef.current?.start, mentionRef.current?.end)
                    )
                ) {
                    mentionRef.current = {}
                }
            }
        },
    })

    return (
        <div
            className={classNames('w-full flex flex-col InputBar relative rounded-lg', className, {
                ' background 111-111': linkMeta || loadingMeta,
            })}>
            <div
                style={{
                    height,
                    borderRadius: '0.5rem',
                    ...style,
                }}
                className={classNames('w-full flex  relative', className, bordered && 'border')}>
                {!textOnly && (
                    <div
                        onClick={handleOnClicks.options}
                        style={{padding: isSm ? '0 0.6rem' : '0 0.7rem'}}
                        className="flex flex-center cursor-pointer">
                        <PiPlusBold
                            size={isSm ? 16 : 18}
                            className="text-color-300 hover:text-color-100"
                        />
                    </div>
                )}
                {!textOnly && (
                    <div
                        className="bg-gray-400 self-center"
                        style={{
                            width: 1,
                            height: '50%',
                        }}
                    />
                )}
                <ContentEditableInput
                    placeholder={`${translate(placeholder)}${renderIfElse(
                        isSm || rows === 1,
                        '',
                        ' \n' + translate('Use Shift+Enter to break line')
                    )}`}
                    value={text}
                    ref={textAreaRef}
                    onChange={handleOnchange}
                    onSelect={handleSelect}
                    onKeyDown={handleOnKeyDown}
                    style={{
                        height: rows !== 1 && height - 3,
                        fontSize: rows === 1 ? 13 : 14,
                        whiteSpace: rows === 1 ? 'nowrap' : 'pre-wrap',
                        width: rows === 1 ? (isSm ? 'calc(98% - 20px)' : '98%') : '100%',
                        overflowX: rows === 1 && 'hidden',
                        paddingRight: rows !== 1 && 32,
                        ...style,
                    }}
                    className={classNames(
                        'pl-3 py-2 flex-1 bg-transparent outline-none ',
                        rows > 1 ? 'overflow-auto scrollBarThin' : ''
                    )}
                    onPaste={handlePaste}
                />
                {isOpenedSuggestions && (
                    <div
                        style={{
                            ...(placement === 'top'
                                ? {top: height}
                                : placement === 'bottom'
                                    ? {bottom: height}
                                    : {}),
                            maxWidth: isSm ? '100%' : '500px',
                            width: '100%',
                        }}
                        className="my-2 absolute background shadow-md border border-color-50 rounded-md animated faster fadeInUp z-10 custom-list">
                        <Spin indicator={null} spinning={!!mentionLoading}>
                            <SelectList
                                onSelected={(e) => {
                                    e.props.onClick()
                                }}>
                                {[
                                    ...(actions?.length > 0 ? [{..._.first(actions), fixed: true}] : []),
                                    ...suggestions,
                                ].map(renderMention({onClick: handleMentionClick}))}
                            </SelectList>
                        </Spin>
                    </div>
                )}
                {/* Submit button — layout thay đổi tùy message mode, logic giống nhau */}
                <Button
                    disabled={!isReady || !canSubmit}
                    icon={
                        canSubmit
                            ? <HiPaperAirplane size={isSm ? 18 : 20} />
                            : <LoadingOutlined size={isSm ? 18 : 20} />
                    }
                    style={{
                        padding: 0,
                        background: 'transparent',
                        ...(!message
                            ? {
                                position: 'absolute',
                                right: 2,
                                bottom: height === 45 ? '50%' : 2,
                                transform: height === 45 ? 'translate(0%, 50%)' : undefined,
                            }
                            : {right: 0, bottom: 0}),
                    }}
                    className={classNames(
                        'button-rounded-md no-border flex flex-center',
                        isReady && canSubmit ? 'text-primary cursor-pointer' : 'text-color-400 cursor-not-allow'
                    )}
                    onClick={() => handleSubmit(textRef.current, imageIds)}
                />
            </div>
            {placement && (
                <div
                    style={{
                        ...(placement === 'top'
                            ? {top: height + 5}
                            : placement === 'bottom'
                                ? {bottom: height + 5}
                                : {}),
                        maxWidth: isSm ? '100%' : '500px',
                        width: '100%',
                    }}
                    className="my-2 absolute background shadow-md rounded-md animated faster fadeInUp custom-list z-10">
                    {isOpenedTagSuggestions && (
                        <Spin indicator={null} spinning={!!tagsLoading}>
                            <SelectList
                                onSelected={(e) => {
                                    e.props.onClick()
                                }}>
                                {tags.map(({name, id, type, label, avatar}, index) => (
                                    <MentionSuggestionItem
                                        key={index}
                                        title={label}
                                        {...{id, name, type, avatar}}
                                        showAvatar={false}
                                        onClick={() => {
                                            if (mentionRef.current?.prefix && mentionRef.current?.text) {
                                                insertHash(name)
                                            }
                                        }}
                                    />
                                ))}
                            </SelectList>
                        </Spin>
                    )}
                    {loadingMeta && (
                        <div className="p-3 flex">
                            <LoadingSkeleton />
                        </div>
                    )}
                    {linkMeta && (
                        <>
                            {!!ReactPlayer.canPlay(linkMeta.url) ? (
                                <>
                                    <VideoEmbed
                                        title={_.get(linkMeta, 'title')}
                                        url={_.get(linkMeta, 'url')}
                                        subTitle={_.get(linkMeta, 'host_url') || _.get(linkMeta, 'url')}
                                        description={_.get(linkMeta, 'description')}
                                        image={_.get(linkMeta, 'photo')}
                                    />
                                    <Avatar
                                        onClick={() => setLinkMeta(null)}
                                        style={{position: 'absolute', right: -5, top: -5}}
                                        icon={<IoIosClose size={14} />}
                                        size={20}
                                        className="flex flex-center text-color-300 background-100 hover:background-200 cursor-pointer"
                                    />
                                </>
                            ) : (
                                <div className="p-2 relative">
                                    <BaseEmbed
                                        title={_.get(linkMeta, 'title')}
                                        subTitle={_.get(linkMeta, 'host_url') || _.get(linkMeta, 'url')}
                                        description={_.get(linkMeta, 'description')}
                                        image={_.get(linkMeta, 'photo')}
                                    />
                                    <Avatar
                                        onClick={() => setLinkMeta(null)}
                                        style={{position: 'absolute', right: -5, top: -5}}
                                        icon={<IoIosClose size={14} />}
                                        size={20}
                                        className="flex flex-center text-color-300 background-100 hover:background-200 cursor-pointer"
                                    />
                                </div>
                            )}
                        </>
                    )}
                    {select && (
                        <div ref={popupRef} className="flex">
                            {select === 'options' && (
                                <List
                                    bordered
                                    className="custom-list border border-color-50 rounded-md">
                                    <List.Item
                                        className="font-semibold hover:text-primary cursor-pointer"
                                        onClick={() => {
                                            onItemClick('createImagePost')
                                        }}
                                        style={gridStyle}>
                                        <Icon className="mr-3 text-red-500" component={RiImageLine} />
                                        {translate('image')}
                                    </List.Item>
                                    <List.Item
                                        className="font-semibold hover:text-primary cursor-pointer"
                                        onClick={() => {
                                            onItemClick('createPoll')
                                        }}
                                        style={gridStyle}>
                                        <Icon
                                            className="mr-3 text-red-500"
                                            component={RiBarChart2Fill}
                                        />
                                        {translate('poll')}
                                    </List.Item>
                                    <PermissionContext.Consumer>
                                        {(permissions) =>
                                            !!_.get(permissions, permissionCodes.canPostArticle) && (
                                                <List.Item
                                                    className="font-semibold hover:text-primary cursor-pointer"
                                                    onClick={() => {
                                                        const createArticleURL =
                                                            articleModel.getLinkToCreate(item)
                                                        history.push({pathname: createArticleURL})
                                                    }}
                                                    style={gridStyle}>
                                                    <Icon
                                                        className="mr-3 text-red-500"
                                                        component={RiQuillPenFill}
                                                    />
                                                    {translate('articles')}
                                                </List.Item>
                                            )
                                        }
                                    </PermissionContext.Consumer>
                                    <List.Item
                                        className="font-semibold hover:text-primary cursor-pointer"
                                        onClick={() => {
                                            onItemClick('createAsk')
                                        }}
                                        style={gridStyle}>
                                        <Icon
                                            className="mr-3 text-red-500"
                                            component={RiWechatLine}
                                        />
                                        {translate('q-and-a')}
                                    </List.Item>
                                </List>
                            )}
                        </div>
                    )}
                </div>
            )}
        </div>
    )
}


const LoginHolder = () => {
    const t = useTranslate()

    return (
        <div className="w-full flex flex-col InputBar">
            <div
                className="w-full flex items-stretch bg-gray-300 border-gray-500  border background"
                style={{
                    height: 45,
                    borderRadius: 4,
                }}>
                <div className="flex-1">{t('need login')}</div>
                <Link
                    to={{
                        pathname: '/login',
                        state: {isModal: true},
                    }}>
                    {t('need login')}
                </Link>
            </div>
        </div>
    )
}
export default connect((state) => {
    return {
        isLogin: !!getLogin(state),
    }
})(
    branch(
        ({isLogin}) => false && !isLogin,
        () => LoginHolder
    )(({mention_data, ...props}) => (
        <MentionDataProvider initialValue={mention_data}>
            <InputBar
                mention_count={Object.keys(mention_data ?? {}).length}
                {...props}
            />
        </MentionDataProvider>
    ))
)